import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import React, { useRef, useState } from 'react';
import OneOffBenefitForm, {
  OneOffBenefitFormRef,
  OneOffBenefitFormValues,
} from './OneOffBenefitForm';

type EditOneOffBenefitProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: OneOffBenefitFormValues) => Promise<void>;
  data: IBIK;
};

const EditOneOffBenefitModal: React.FC<EditOneOffBenefitProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditOneOffBenefitProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<OneOffBenefitFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: OneOffBenefitFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editOneOffBenefit']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <OneOffBenefitForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          description: data.description,
          taxPeriod: data.taxPeriod,
          eeContribution: data.eeContribution?.toString(),
          totalEeContribution: data.totalEeContribution?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditOneOffBenefitModal;
